import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import FlexTable from "../../../components/ui-components/FlexTable";
import { buildRows } from "./dataQualityRows";

const columns = [
  { Header: "Control", accessor: "control" },
  { Header: "Result", accessor: "result", align: "right" },
];

/**
 * DataQualityBlock - the appendix's data-quality & control-summary table (data_quality block
 * type).
 *
 * GET /api/v1/board-reports/{boardReportId}/runs/{runId}/figures/data-quality -> envelope key
 * "data_quality" -> boardfigures.DataQuality (internal/boardfigures/quality.go's
 * BuildDataQuality): { allocation_coverage_pct, estimated_pct, estimated_available,
 * forecast_confidence, unexplained_variance, data_complete_through }.
 */
const DataQualityBlock = ({ title = "Data quality & control summary", boardReportId, runId }) => {
  const { data, isLoading, error } = useBlockData(
    `/api/v1/board-reports/${boardReportId}/runs/${runId}/figures/data-quality`
  );

  const dq = data?.data_quality;
  const rows = dq ? buildRows(dq) : [];

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error} className="a4-data-quality">
      {rows.length === 0 ? (
        <p className="a4-data-quality-empty">No data-quality figures available.</p>
      ) : (
        <FlexTable columns={columns} data={rows} getRowId={(row) => row.id} />
      )}
    </BaseBlock>
  );
};

DataQualityBlock.propTypes = {
  title: PropTypes.string,
  boardReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  runId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DataQualityBlock;
